import React, { useState, useEffect, useMemo } from 'react';
import { API_URL, customStyles, secret_key, storedData } from '../components/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import Swal from "sweetalert2";
import Modal from 'react-modal';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import loading1 from "../assets/loading.gif"

function Contacts() {
  const [searchTerm, setSearchTerm] = useState('');
  const [contacts, setContacts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [contact_groups, setContactgroups] = useState([]);
  let navigate = useNavigate();

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const fetchContacts = () => {
    // const getContactsURL = `${API_URL}/get_contacts?page=${page}&limit=${50}`;
    const getContactsURL = `${API_URL}/get_contacts_bycompanyid/${logeduserData?.company_id}?page=${page}&limit=${50}`;
    let getContactsConfig = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactsURL,
      headers: { 
        'Authorization': token
      }
    };

    axios
    .request(getContactsConfig)
    .then((response) => {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setContacts([...contacts, ...response.data]);
          setPage(page + 1);
        }
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        navigate(0);
      }
    });
  };

  useEffect(() => {
    fetchContacts();
  }, []);
  
  const fetchContactGroups = () => {
    const getContactGroupssURL = `${API_URL}/get_groupsByCompanyid/${logeduserData?.company_id}?page=1&limit=5000`;

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactGroupssURL,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      const formattedOptions = response.data.map((group) => ({
        value: group.id,
        label: group.id+" "+group.group_name
      }));
      setContactgroups(formattedOptions);
    })
    .catch((error) => {
      console.log(error?.response)
    });
  };


  useEffect(() => {
    fetchContactGroups();
  }, []);

  // useEffect(() => {
  //   setContacts([]);
  //   setPage(1);
  //   setHasMore(true);
  //   fetchContacts(1);
  // }, [searchTerm]);

  // const handleSearch = (event) => {
  //   const searchTerm = event.target.value;
  //   setSearchTerm(searchTerm);
  // };
  useEffect(() => {
    setPage(1); // Reset page to 1 when search term changes
    setContacts([]);
    setHasMore(true);
    fetchContacts(1);
  }, [searchTerm]);

  useEffect(() => {
    if (hasMore) {
      fetchContacts(page);
    }
  }, [page]);

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  const filteredContacts = contacts.filter((contact) => {
    const { group_name, full_name, phone_no } = contact;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      group_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      full_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) 
    );
  });

  const loadMoreContacts = () => {
    fetchContacts(); // Fetch more contacts when the user scrolls to the bottom
  };

  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
      setIsOpen(true);
    }
  
    const closeModal = () => {
      setIsOpen(false);
    }

  const [userdata, setUserContact] = useState({
    full_name: "",
    phone_no: "",
    contact_group_id: "",
    company_id: logeduserData?.company_id
  });

  const handleChange = (e) =>{
    const newdata = { ...userdata }
    newdata[e.target.id] = e.target.value
    setUserContact(newdata)
  } 

  const [isSubmitting, setIsSubmitting] = useState(false);
  const createContact = (ev) => {
    ev.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/new_contact`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : userdata
    };
    
    axios.request(config)
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "New contact was created successfully",
      })
      .then(() => {
        navigate(0);
      });
      setIsSubmitting(false);
    })
    .catch((error) => {
       Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      });
      setIsSubmitting(false);
    }); 
   }
    
    

  const [editmodalIsOpen, setEditIsOpen] = useState(false);
  const [contacttoedit, setcontacttoedit] = useState("");
  const [editcontact, seteditcontact] = useState({
    full_name: "",
    phone_no: "",
    
  });
  const openEditModal = (groupid) => {
    setEditIsOpen(true);
    setcontacttoedit(groupid)

    const getGroupByID = () => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_contactByid/${groupid}`,
        headers: { 
          'Authorization': token
        }
      }
      
      axios.request(config)
      .then((response) => {
        seteditcontact(response.data)         
      })
      .catch((error) => {
        console.log(error?.response)
      });
    };
    
    getGroupByID();
  }

  const closeEditModal = () => {
    setEditIsOpen(false);
  }

  const handleeditChange = (e) => {
    const editdata = { ...editcontact }
    editdata[e.target.id] = e.target.value
    seteditcontact(editdata)
  }

  const editContact = (ev) => {
    ev.preventDefault()  
    
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${API_URL}/edit_contact/${contacttoedit}`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : editcontact
    };
    
    axios.request(config)
    .then((response) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Contact edited successfully",
      })
      .then(() => {
        navigate(0);
      });
    })
    .catch((error) => {
      setIsSubmitting(false);
       Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        });
    });
  }


  const deleteContact = (contactid) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {

        if (isSubmitting) {
          return;
        }
    
        setIsSubmitting(true);
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/delete_contact/${contactid}`,
          headers: { 
            'Authorization': token
          }
        };
        
        axios.request(config)
        .then((response) => {
          setTimeout(() => {
            setIsSubmitting(false);
            Swal.fire({
              title: 'Deleted!',
              text: 'The item has been deleted.',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
            })
            .then(() => {
              navigate(0);
            });
          }, 1000);
          // window.location.reload();
        })
        .catch((error) => {
          setIsSubmitting(false);
           Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.response?.data?.error,
          });
        });
      }
    });
  }
 

  return (
    <div style={{ paddingLeft: '10px' }}>
      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}

       <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Contacts</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Contacts</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              New Contact
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={createContact}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Full Name</span>
                    <input type="text" 
                      placeholder="Enter full name" 
                      required 
                      onChange={handleChange}
                      id='full_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Phone Number</span>
                    <input type="tel" 
                      required
                      placeholder="Enter phone number"  
                      pattern="(0[0-9]{9})|([0-9]{9})|[0-9]{10,12}|(\+[0-9]{10,12})"
                      onChange={handleChange}
                      id='phone_no'
                    />
                  </div>  
                  <div className="input-box">
                    <span className="details">Contact Group</span>
                    <Select
                      options={contact_groups}
                      required
                      placeholder="Select contact group:"
                      onChange={(selectedOptions) =>
                        setUserContact({
                          ...userdata,
                          contact_group_id: selectedOptions.value
                        })
                      }
                      id='contact_group_id'
                    />
                  </div>                
                </div>
               
                <div className="button">
                  <input type="submit" value="Save" />
                </div>
              </form>
            </div>
          </div>

        </Modal>



         <Modal
          isOpen={editmodalIsOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Edit Contact 
              <i onClick={closeEditModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={editContact}> 
                <div className="user-details">
                
                  <div className="input-box">
                    <span className="details">full Name</span>
                    <input type="text" 
                      placeholder="Enter full name" 
                      required 
                      onChange={handleeditChange}
                      id='full_name'
                      value={editcontact.full_name}
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Phone Number</span>
                    <input type="text" 
                      placeholder="Enter Phone Number"  
                      onChange={handleeditChange}
                      required
                      id='phone_no'
                      value={editcontact.phone_no}
                    />
                  </div>
                  
                  
                </div>
               
                <div className="button">
                  <input type="submit" value="Update" />
                </div>
              </form>
            </div>
          </div>

        </Modal>



        

      <form className="form-inline justify-content-end searchBar">
        <div id="add-btn" onClick={openModal}>
      <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
      Add Contact
      </div>
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
          {/* <input
            className="form-control form-control-navbar"
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          /> */}

        </div>
      </form>

          <InfiniteScroll

            dataLength={filteredContacts.length}
            next={loadMoreContacts}
            hasMore={hasMore} // Set this to false when there is no more data to load
            loader={filteredContacts.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more contacts to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th>Phone No</th>
                  <th>Group</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                  {filteredContacts.map((contact, index) => (
                    <tr key={contact.id}>
                      <td>{index + 1}</td>
                      <td>{contact.full_name}</td>
                      <td>{contact.phone_no}</td>
                      <td>{contact.group_name}</td>
                      <td className="dropdown">
                        <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Action
                          <span className="caret" /></button>
                        <ul className="dropdown-menu companyActions">
                              <li onClick={() => openEditModal(contact.id)} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                              <i className="fa fa-edit"></i>
                              <span>Edit contact</span>
                              </li>
                              <li onClick={() => deleteContact(contact.id)} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                              <i className="fa fa-trash"></i>
                              <span>Delete contact</span>
                              </li>
                        </ul>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  );
}

export default Contacts
